import React from 'react';
import { StaticReferencePage } from './StaticReferencePage';
import { useData } from '../../contexts/DataContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { TABLE_COLUMNS } from '../../constants/tables';
import { Country } from '../../types';

export const CountriesPage: React.FC = () => {
  const { t } = useLanguage();
  const { countries } = useData();

  return (
    <StaticReferencePage<Country>
      title={t('references.countries')}
      items={countries.items}
      columns={TABLE_COLUMNS.COUNTRIES}
    />
  );
};
